import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'

import Login from '@/pages/PageLogin'
import PageShipmentList from '@/pages/PageShipmentList'
import PageShipment from '@/pages/PageShipment'
import PageTrackingRequestList from '@/pages/PageTrackingRequestList'
import PageTrackingRequestAdd from '@/pages/PageTrackingRequestAdd'
import PageTrackingRequest from '@/pages/PageTrackingRequest'
import PageDashboard from '@/pages/PageDashboard'
import PageMapLocations from '@/pages/PageMapLocations'
import PageUserConfig from '@/pages/PageUserConfig'
import PageTeamsConfig from '@/pages/PageTeamsConfig'
import PageProjectsConfig from '@/pages/PageProjectsConfig'
import PageFreeDaysConfig from '@/pages/PageFreeDaysConfig'
import PageBi from '@/pages/PageBi'
import PageProduct from '@/pages/PageProduct'
import PageContact from '@/pages/PageContact'
import PageTermsConditions from '@/pages/PageTermsConditions'
import PagePrivacyPolicy from '@/pages/PagePrivacyPolicy'

// Conventional
import PageShipmentConventionalList from '@/pages/conventional/PageShipmentConventionalList'
import PageShipmentConventional from '@/pages/conventional/PageShipmentConventional'
import PageConventionalTrackingRequestAdd from '@/pages/conventional/PageConventionalTrackingRequestAdd'
import PageConventionalTrackingRequest from '@/pages/conventional/PageConventionalTrackingRequestsList'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/terms-conditions',
      name: 'terms-conditions',
      component: PageTermsConditions
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PagePrivacyPolicy
    },
    {
      path: '/contact',
      name: 'contact',
      component: PageContact
    },
    {
      path: '/',
      name: 'product',
      component: PageProduct
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: PageDashboard,
      beforeEnter: requireAuth
    },
    {
      path: '/shipments',
      name: 'shipment-list',
      component: PageShipmentList,
      beforeEnter: requireAuth
    },
    {
      path: '/shipments/:id',
      name: 'shipment',
      component: PageShipment,
      beforeEnter: requireAuth
    },
    {
      path: '/tracking-requests',
      name: 'tracking-request-list',
      component: PageTrackingRequestList,
      beforeEnter: requireAuth
    },
    {
      path: '/add-tracking-request',
      name: 'tracking-request-add',
      component: PageTrackingRequestAdd,
      beforeEnter: requireAuth
    },
    {
      path: '/tracking-requests/:id',
      name: 'tracking-request',
      component: PageTrackingRequest,
      beforeEnter: requireAuth
    },
    {
      path: '/map-locations',
      name: 'map-locations',
      component: PageMapLocations,
      beforeEnter: requireAuth
    },
    {
      path: '/bi',
      name: 'bi',
      component: PageBi,
      beforeEnter: requireAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/user-config',
      name: 'user-config',
      component: PageUserConfig,
      beforeEnter: requireAuth
    },
    {
      path: '/teams-config',
      name: 'teams-config',
      component: PageTeamsConfig,
      beforeEnter: requireAuth
    },
    {
      path: '/projects-config',
      name: 'projects-config',
      component: PageProjectsConfig,
      beforeEnter: requireAuth
    },
    {
      path: '/free-days-config',
      name: 'free-days-config',
      component: PageFreeDaysConfig,
      beforeEnter: requireAuth
    },
    // CONVENTIONAL
    {
      path: '/conventional/shipments',
      name: 'shipment-conventional-list',
      component: PageShipmentConventionalList,
      beforeEnter: showConventional
    },
    {
      path: '/conventional/tracking-requests',
      name: 'conventional-tracking-request-list',
      component: PageConventionalTrackingRequest,
      beforeEnter: showConventional
    },
    {
      path: '/conventional/shipments/:id',
      name: 'shipment-conventional',
      component: PageShipmentConventional,
      beforeEnter: showConventional
    },
    {
      path: '/conventional/add-tracking-request',
      name: 'conventional-tracking-request-add',
      component: PageConventionalTrackingRequestAdd,
      beforeEnter: showConventional
    }
  ],
  scrollBehavior () {
    return new Promise((resolve) => {
      resolve({ left: 0, top: 0 })
    })
  }
})

function requireAuth (to, from, next) {
  if (!store.state.auth.authenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function showConventional (to, from, next) {
  if (!store.state.auth.authenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    if (store.state.auth.isConventional) {
      next()
    } else {
      next({
        path: '/dashboard',
        query: { redirect: to.fullPath }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js